import '../../assets/index29.css';var N = Object.defineProperty;
var s = Object.getOwnPropertySymbols;
var T = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var _ = (e, n, i) => n in e ? N(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i, m = (e, n) => {
  for (var i in n || (n = {}))
    T.call(n, i) && _(e, i, n[i]);
  if (s)
    for (var i of s(n))
      c.call(n, i) && _(e, i, n[i]);
  return e;
};
var p = (e, n) => {
  var i = {};
  for (var t in e)
    T.call(e, t) && n.indexOf(t) < 0 && (i[t] = e[t]);
  if (e != null && s)
    for (var t of s(e))
      n.indexOf(t) < 0 && c.call(e, t) && (i[t] = e[t]);
  return i;
};
import { jsxs as R, jsx as d } from "react/jsx-runtime";
import { forwardRef as h } from "react";
import { ErrorMessage as j } from "../../molecules/ErrorMessage/index.js";
import { T as v } from "../../TextInput-DDoibTqv.js";
const $ = "InlineTextField-module__inlineTextFieldRoot___ZqNoQ", y = "InlineTextField-module__inlineTextField___mgxTe", E = "InlineTextField-module__error___9ljVo", V = "InlineTextField-module__supportingText___lVO5J", q = "InlineTextField-module__description___5Kxor", l = {
  inlineTextFieldRoot: $,
  inlineTextField: y,
  error: E,
  supportingText: V,
  description: q
}, w = h(
  (C, f) => {
    var x = C, {
      defaultValue: e,
      disabled: n,
      placeholder: i = "Inline text field",
      onChange: t,
      value: a,
      className: F,
      width: u,
      error: o,
      description: r
    } = x, I = p(x, [
      "defaultValue",
      "disabled",
      "placeholder",
      "onChange",
      "value",
      "className",
      "width",
      "error",
      "description"
    ]);
    const g = !!o;
    return /* @__PURE__ */ R("div", { className: l.inlineTextFieldRoot, children: [
      /* @__PURE__ */ d(
        v,
        m({
          disabled: n,
          value: a,
          defaultValue: e,
          onChange: t,
          placeholder: i,
          classNames: {
            input: `${l.inlineTextField} ${F || ""} ${g ? l.error : ""}`
          },
          style: { width: u },
          ref: f
        }, I)
      ),
      (r || o) && /* @__PURE__ */ d("div", { className: l.supportingText, children: o ? /* @__PURE__ */ d(j, { error: o }) : /* @__PURE__ */ d("div", { className: l.description, children: r }) })
    ] });
  }
), B = w;
B.displayName = "InlineTextField";
export {
  B as InlineTextField
};
